<template>

<div>
            

    
  <div class="user-client" style="height: calc(100% - 60px)">
    
    <div  class="row" style="border-bottom: 1px solid #CCC; margin-left: 0px ; margin-right: 0px; padding:10px">
      <div class="col-xs-8" style="border-right: 0px solid #CCC;" >
      <h2 style="display: inline;">
        <i class="fa fa-user" :class="typeIconClass" aria-hidden="true"></i>
        Agent: 
        <span v-text="sexText"></span>
        <span v-text="userCallCenter.firstName"></span>
        <span v-text="userCallCenter.lastName"></span> - 
        <!-- <span v-text="aclText" class="small"></span> -->
        <button class="btn btn-link" type="button" @click="$emit('logout')" title="von ccpronto abmelden">
          <span style="padding-right: 5px;">Logout</span>
          <span class="">({{aclText}})</span>
        </button>

        </h2>
      </div>
      <div class="col-xs-4 " style="">

                       
        <div v-if="!acdLogedIn" class="text-right">
          <span v-if="!acdKey" style="color:#777; font-size:1.3em;" v-text="'Kein AcdKey/Platz vorhanden'"></span>
          <div v-else>
            <span style="color:#777; font-size:1.3em;"><a href="http://acd1.in-acd.de/acdweb/index.jsf" target="_blank">ACD:</a> {{acdKey}} </span>
            <button class="btn btn-link" type="button" @click="onAcdLogin">
              Anmelden
              <i v-show="false" class="fa fa-sign-in" title="ACD Login" aria-hidden="true"></i>
            </button>
          </div>
          <!--
          <div class="input-group">
            <input type="text" class="form-control" v-model="acdKey" placeholder="Platz/ACD-Login">
            <span class="input-group-btn">
              <button class="btn btn-primary" type="button" @click="onAcdLogin">
                <i class="fa fa-sign-in" title="ACD Login" aria-hidden="true"></i>
              </button>
            </span>
          </div>
          -->
        </div>
                   
        <div v-if="acdLogedIn" class="text-right">
          <span style="color:#777; font-size:1.3em;">
          <a href="http://acd1.in-acd.de/acdweb/index.jsf" target="_blank">ACD:</a> {{acdKey}} </span>
          <button  v-if="!acdPlay" class="btn btn-sm btn-default" type="button" @click="onAcdPauseEnd" title="ACD starten">
            <i  v-show="1" class="fa fa-play " aria-hidden="true"></i>
          </button>
          <button v-if="acdPlay"class="btn btn-sm btn-default" type="button" @click="onAcdPauseStart" title="ACD pause">
            <i  v-show="1" class="fa fa-pause " aria-hidden="true"></i>
          </button>
          <button class="btn btn-link" type="button" @click="onAcdLogout">
            Abmelden 
            <i v-show="false" class="fa fa-sign-out" title="ACD Logout" aria-hidden="true"></i>
          </button>
        </div>
                   
                   
                    
<!--
           <span class="">
            ACD:
            
            <span v-if="!login.acdKey" v-text="'nicht angemeldet'"></span>
            <span v-text="login.acdKey" ></span>

          </span>  
-->          
        
      </div>
        

    </div> 

    <div class="row" style="height: calc(100% - 45px)">

      <div class="col-xs-8" style="border-right: 0px solid #CCC; height:100%" >
       <div class="cc-memo-list">
        <div class="panel-group" id="user-client-memo-accordion" role="tablist" aria-multiselectable="true">
          <cc-memo
            class="cc-memo-item" 
            v-for="(memo, index) in memos"
            :collapseIn="(false)"
            :data_parent="'user-client-memo-accordion'"
            :memo="memo"
            :key="memo.id" 
            @remove="onRemoveMemo"
            @update="onSetMemo">
          </cc-memo>
        </div>
      
         <div v-show="!memos.length" class="alert alert-warning" role="alert">Keine internen Vorgaben</div>
<!--
         <cc-memo 
            v-if="userCallCenter.id"
            class="cc-kombox-item"
            :idCompany= 0
            :idUser="userCallCenter.id"
            @insert="onAddMemo">
         </cc-memo>
-->         
      </div>      
      </div>
<!--
      <div class="col-xs-4" style="height:100%">
      <div class="cc-kombox-list">
        <cc-kombox 
          class="cc-kombox-item" 
          v-for="kombox in komboxes"
          :kombox="kombox"
          :key="kombox.id" 
          @add-shipping="onKomboxAddShipping"
          @remove-shipping="onKomboxRemoveShipping"
          @remove="onRemoveKombox"
          @update="onSetKombox">
        </cc-kombox>
        
        <div v-show="!komboxes.length" class="alert alert-warning text-center" role="alert">Keine Komboxen</div>
        
        <cc-kombox 
            v-if="userCallCenter.id > 0 && idCompanyClient > 0"
            class="cc-kombox-item" 
            :idCompany="idCompanyClient"
            :idUser="userCallCenter.id"
            @insert="onAddKombox">
         </cc-kombox>

      </div>
      </div>
-->    

    </div>
          
  </div>            
</div>                   
    
</template>



<script>

import Kombox from './Kombox.vue'
import Memo from './Memo.vue'
import bus from './common/bus'
import * as miscConf from './common/misc.conf'


export default {
    
  components: {
    'cc-kombox': Kombox,
    'cc-memo': Memo,
  },
  
  data () {
    return {
      idCompanyClient: 0,
      userCallCenter: bus.login.userCallCenter,
      login: bus.login,
      memos:[],
      komboxes:[],
      acdPlay: false,
      acdKey: bus.login.acdKey,
      acdLogedIn : false,
      
      userCallCenterType: {
         '': {class: 'fa-question', text: 'Unbekannt', sexText: ''},
         0: {class: 'fa-question', text: 'Unbekannt', sexText: ''},
         1: {class: 'fa-user', text: 'Herr', sexText: 'Herr'},
         2: {class: 'fa-user', text: 'Frau', sexText: 'Frau'},
         3: {class: 'fa-users', text: 'Abteilung', sexText: ''},
         4: {class: 'fa-commenting', text: 'Thema', sexText: ''}
      }

    }
  },
  
  created: function () {
    bus.registerOnResetCompanyClient(this.onResetCompanyClient);
    this.loadMemos();
  },
  
  computed: {
    
    aclText: function() {
      // ToDo move to a config file -> i18n
      return miscConf.aclText(bus.login.userCallCenter.acl);
    },

    
    sexText: function () {
      if(typeof this.userCallCenter.idSex == 'string'){
        return this.userCallCenterType[this.userCallCenter.idSex].sexText;
      }
    },

    typeIconClass: function () {
      if(typeof this.userCallCenter.idSex == 'string'){
        return this.userCallCenterType[this.userCallCenter.idSex].class
      }
    },
      
    
  },
  
  methods: {

    onResetCompanyClient: function () {
      this.loadMemos();
      console.log('UserCallCenter:mounted()');
    },

    onAcdLogin: function () {
      this.$http.post(bus.config.path + '/acd/logout/2/' + this.acdKey, null ).then((response) => {
        this.$http.post(bus.config.path + '/acd/login/2/' + this.acdKey, null ).then((response) => {
          if(response.data == true){
            this.acdLogedIn = true;
            this.acdPlay = true;
          }
        }, (response) => {
        // error callback
        });
      }, (response) => {
      // error callback
      });
    },

    onAcdLogout: function () {
      this.$http.post(bus.config.path + '/acd/logout/2/' + this.acdKey, null ).then((response) => {
          if(response.data == true){
            this.acdLogedIn = false;
          }
      }, (response) => {
      // error callback
      });
    },

    onAcdPauseStart: function () {
      this.$http.post(bus.config.path + '/acd/pause/start/2/' + this.acdKey, null ).then((response) => {
        this.acdPlay = !response.data;
      }, (response) => {
      // error callback
      });
    },

    onAcdPauseEnd: function () {
      this.$http.post(bus.config.path + '/acd/pause/end/2/' + this.acdKey, null ).then((response) => {
        this.acdPlay = response.data;
      }, (response) => {
      // error callback
      });
    },

    onRemoveMemo: function (memo) {
      const indexOf = this.memos.indexOf(memo);
      if(indexOf != -1){
        this.memos.splice(indexOf, 1);
      }
    },
    
    onSetMemo: function (memo) {
      // Note: kombox is a reference or a clone
      const indexOf = _.findIndex(this.memos, ['id', memo.id]);
      if(indexOf != -1){
        this.$set(this.memos, indexOf, memo);
      }
    },
    
    onAddMemo: function (memo) {
        this.memos.push(memo);
    },
    

    onRemoveKombox: function (kombox) {
      const indexOf = this.komboxes.indexOf(kombox);
      if(indexOf != -1){
        this.komboxes.splice(indexOf, 1);
      }
    },
    

    reset: function () {
      this.userCallCenter = {};
      this.memos = [];
    },
    

    
    loadUserCallCenter: function (idUserCallCenter) {
      this.$http.get(bus.config.path + '/user/callcenter/' + bus.call.idUserCallCenter).then((response) => {
        this.userCallCenter = response.data;
        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },

    loadMemos: function (idUserCallCenter, idCompanyClient) {
      this.$http.get(bus.config.path + '/user/memos/' + this.userCallCenter.id + '/' + bus.call.idCompanyCallCenter, {params: {typ: '2'}}).then((response) => {
        this.memos = response.data;
        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },

    
  }
  
}
</script>



<style scoped>

.panel-group, .panel{
    margin-bottom: 0px;
  }  
  
  .xxxuser-client{
    border: 0px solid lightgrey;
    box-shadow: 0px 0px 3px grey;
    margin-top: 20px;
  }
  

  h2 .fa {
    padding-right: 6px;
    color: #337ab7;
}

.btn-default .fa {
    padding-right: 0px;
    color: #337ab7;
}
  
.cc-kombox-item{
    border-bottom: 1px solid lightgrey;
    padding-top: 5px;
    padding-bottom: 5px;
  
}  

.cc-kombox-item:hover,
.cc-memo-item:hover{
  background-color: #fcf8e3;
}


  .cc-kombox-list,
  .cc-memo-list{
    height: 100%;
    overflow: auto;
    
  }
</style>



// WEBPACK FOOTER //
// UserCallCenter.vue?4ae518ed